// Definição para o modal de busca de Operações Fiscais (genérica)
// Utilizada no CampoBusca da Matriz Fiscal e outros componentes que precisam selecionar operações

import { ST } from '@/constants/ST'

export const criarConfigBuscaOperacao = (idOrganizacao) => ({
  label: 'Operação Fiscal',
  placeholder: 'ID da Operação...',
  titulo: 'Selecionar Operação Fiscal',
  endpointApi: 'Operacoes',
  idField: 'idOperacao',
  descField: 'descricaoCompleta',
  displayField: 'idOperacao',
  camposFiltro: [
    { label: 'Descrição', model: 'busca', tipo: 'text' },
    { label: 'Empresa', model: 'idOrganizacao', tipo: 'hidden', value: idOrganizacao }
  ],
  filtrosFixos: {
    lstStatus: ST.Ativo
  },
  colunasGrid: [
    { header: 'ID', dataField: 'idOperacao', width: '8%' },
    { header: 'Descrição', dataField: 'descricao', width: '42%' },
    { header: 'Tipo Movimento', dataField: 'lstTipoMovimentoDescricao', width: '20%' },
    { header: 'CFOP Dentro Estado', dataField: 'cfopDentroEstado', width: '12%' },
    { header: 'CFOP Fora Estado', dataField: 'cfopForaEstado', width: '12%' }
  ]
})
